<script>
  import { settingsStore } from '../stores';
  import { mbtiQuestions, mbtiJobs, calculateMbti } from '../utils/styleCatalog';
  let answers = [];
  let index = 0;
  $: result = calculateMbti(answers) || (!answers.length && $settingsStore.mbtiQuizCompleted && /^[EI][SN][TF][JP]$/.test($settingsStore.mbtiType) ? $settingsStore.mbtiType : null);
  function choose(type) {
    $settingsStore.mbtiType = '';
    answers = [...answers.slice(0, index), type];
    if (index < mbtiQuestions.length - 1) index++;
    else { $settingsStore.mbtiType = calculateMbti(answers); $settingsStore.mbtiQuizCompleted = true; }
  }
  function restart() { answers = []; index = 0; $settingsStore.mbtiType = ''; $settingsStore.mbtiQuizCompleted = false; }
</script>
<div class="quiz">
  {#if result}
    <p>우리 아이의 MBTI</p><h3>{result}</h3><p>{mbtiJobs[result]}</p>
    <button type="button" on:click={restart}>다시 테스트하기</button>
    <p>적용하기를 누르면 이 성격을 담은 기념 이미지를 만들어요.</p>
  {:else}
    <p>{index + 1} / {mbtiQuestions.length}</p>
    <progress value={index} max={mbtiQuestions.length} aria-label="MBTI 테스트 진행률"></progress>
    <h3>{mbtiQuestions[index].question}</h3>
    {#each mbtiQuestions[index].answers as answer}
      <button type="button" on:click={() => choose(answer.type)}>{answer.text}</button>
    {/each}
    {#if index > 0}<button type="button" on:click={() => { index--; answers = answers.slice(0, index); }}>이전 질문</button>{/if}
  {/if}
</div>
<style>
  .quiz { display: grid; gap: 12px; } p { margin: 0; line-height: 1.6; } h3 { margin: 4px 0; line-height: 1.6; }
  button { padding: 14px; border: 1px solid #fe6a3755; border-radius: 12px; background: #fe6a370b; color: inherit; font: inherit; cursor: pointer; text-align: left; }
  button:hover { background: #fe6a3722; } progress { width: 100%; accent-color: #fe6a37; }
</style>
